import React from "react";
import styled, { css } from "styled-components/";
import { IElement } from "core-integration/src/store/elements/types";

//crops player image
const ElementWrapper = styled.div`
  position: absolute;
  left: 0.2px;
  right: 0.2px;
  bottom: 0px;
`;

const ElementName = styled.div<IStyledProps>`
  padding: 0.1rem 0.2rem;
  background-color: ${({ theme }) => theme.colors.blueDarker3};
  color: ${({ theme }) => theme.colors.white};
  color: white;
  font-size: 1rem;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  min-height: 1rem;

  ${(props) =>
    props.element.news &&
    props.element.chance_of_playing_next_round !== null &&
    css`
      background-color: ${
        props.theme.colors.elementStatus[
          props.element.chance_of_playing_next_round
        ].bg
      };
      color: ${
        props.theme.colors.elementStatus[
          props.element.chance_of_playing_next_round
        ].color
      };
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    min-height: 1.6rem;
    font-size: ${({ theme }) => theme.fontSizes[0]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    font-size: ${({ theme }) => theme.fontSizes[1]};
  }
`;

const ElementValue = styled.div`
  padding: 0 0.2rem;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.blueDarker3};
  font-size: 1rem;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    font-size: ${({ theme }) => theme.fontSizes[0]};
  }
`;

interface IStyledProps {
  element: IElement;
}

interface IProps {
  value: React.ReactNode;
}

type Props = IStyledProps & IProps;

const PitchElementData: React.FC<Props> = ({ element, value }) => (
  <ElementWrapper>
    <ElementName element={element}>{element.web_name}</ElementName>
    <ElementValue>{value}</ElementValue>
  </ElementWrapper>
);

export default PitchElementData;
